import { useContext } from 'react'

import { LoadingContext } from '../contexts/loading'

export const useLoading = () => useContext(LoadingContext)

export default useLoading
